import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "hero",
  class: "relative min-h-screen flex items-start overflow-hidden pb-40 md:pb-48 lg:pb-56"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createCommentVNode(" Background image "),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 z-0" }, [
      _createElementVNode("img", {
        src: "/images/hero-bg.webp",
        alt: "Background",
        class: "w-full h-full object-cover",
        loading: "eager",
        fetchpriority: "high"
      }),
      _createElementVNode("div", { class: "absolute inset-0 bg-black/30" })
    ], -1 /* CACHED */)),
    _createCommentVNode(" Animated Logo (fixed position, moves on scroll) "),
    _createElementVNode("div", {
      ref: "logoContainer",
      class: "fixed z-50 transition-all duration-500 ease-out",
      style: _normalizeStyle($options.logoStyle)
    }, [
      _createElementVNode("img", {
        ref: "logo",
        src: "/images/logo-hero.svg",
        alt: "Comptoir Gascon",
        class: "h-auto transition-all duration-500 ease-out",
        style: _normalizeStyle({ width: $options.logoWidth + 'px' })
      }, null, 4 /* STYLE */)
    ], 4 /* STYLE */),
    _createCommentVNode(" Content "),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"relative z-10 container mx-auto px-4 md:px-8 pt-8 md:pt-16 text-white\"><!-- Logo placeholder (invisible, keeps space) --><div class=\"mb-4 md:mb-12 h-48 md:h-32 lg:h-40\"></div><!-- Main content with title on left --><div class=\"flex flex-col px-4 md:px-12 lg:flex-row lg:items-center lg:justify-between\"><!-- Left side: Title and phone box --><div class=\"lg:max-w-3xl text-center md:text-left\"><!-- Tagline --><h1 class=\"text-2xl md:text-4xl lg:text-5xl font-bold font-din leading-tight\"> Le Comptoir Gascon, </h1><p class=\"text-lg md:text-2xl lg:text-3xl mb-2 md:mb-4 font-raleway\"> le QG des professionnels de la restauration. </p><p class=\"text-base md:text-xl text-white mb-6 md:mb-8\"> Spécialiste des brasseries de Bordeaux. </p></div><!-- Right side: Map of Gironde --><div class=\"hidden lg:block lg:flex-shrink-0 lg:ml-8\"><img src=\"/images/carte_gironde.svg\" alt=\"Zones de livraison en Gironde\" class=\"w-80 xl:w-[28rem] 2xl:w-[32rem] h-auto drop-shadow-2xl\"></div></div><!-- Map for mobile &amp; tablet (centered below) --><div class=\"mt-8 md:mt-12 text-center lg:hidden\"><img src=\"/images/carte_gironde.svg\" alt=\"Zones de livraison en Gironde\" class=\"w-80 md:w-96 h-auto mx-auto drop-shadow-2xl\"></div></div>", 1))
  ]))
}